export const STATUS_ACTIVE = "ACTIVE";
export const STATUS_ONBOARDING = "ONBOARDING";
export const STATUS_NOT_ACTIVE = "NOT_ACTIVE";
export const STATUS_DEACTIVATED = "DEACTIVATED";

export const MINUTE_MS = 60000;

export const COMPANY_ID_KEY = "COMPANY_ID"
export const SETTINGS_APP = "app"
export const SETTINGS_GENERAL = "general"